import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export const ErrorMessageBlock = ({ className, ...props }: ComponentProps<'div'>) => {
  return <div className={twMerge('bg-black/5 p-3 font-mono rounded-sm', className)} {...props} />
}
